/* global BX */

document.addEventListener('DOMContentLoaded', () => {
    const productIdInput = document.getElementById('productId');
    const storesWrapper = document.getElementById('catalog-detail__stores');

    if (!productIdInput?.value || !storesWrapper || typeof BX === 'undefined') {
        return;
    }

    const productId = productIdInput.value;

    fetch(`/api/v1/catalog/${productId}/stores`, {
        method: 'GET',
        headers: {
            'Session-Id': BX.bitrix_sessid(),
        },
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.success) {
                setTotalAmount(result.stores);
                buildStores(result.stores);
            } else {
                console.error('Ошибка получения складов');
            }
        })
        .catch((err) => console.error(err));
});

function setTotalAmount(stores) {
    const totalAmountWrapper = document.getElementById('catalog-detail__total-amount');
    if (!totalAmountWrapper) {
        return;
    }

    let totalCount = 0;

    stores.forEach((store) => {
        totalCount += store.amount;
    });

    totalAmountWrapper.textContent = totalCount;
}

function buildStores(stores) {
    const storesWrapper = document.getElementById('catalog-detail__stores');
    if (!storesWrapper) {
        return;
    }

    stores.forEach((store) => {
        const item = document.createElement('div');
        item.textContent = store.storeName;
        const amount = document.createElement('span');
        amount.textContent = store.amount === 0 ? '-' : store.amount;
        item.classList.add('catalog-detail__store');
        amount.classList.add('catalog-detail__store-amount');
        if (store.amount !== 0) {
            amount.classList.add('catalog-detail__store-amount--available');
        }
        item.appendChild(amount);
        storesWrapper.appendChild(item);
    });

    window.refreshAccordionPanel?.(storesWrapper);
}
